module.exports = __webpack_public_path__ + "img/logo.dd2893ef.png";